/**
 * CC-49833 — map the Timekeeper Analysis page's filter state onto CB's
 * `TimekeeperAnalysisFilter` property names before it goes on the wire.
 *
 * This is the actual reason the ten measure columns came back 0.00 while Unbilled
 * Hours/Amount was correct. The legacy CSV endpoint deserializes `filters` with
 * Newtonsoft straight onto TimekeeperAnalysisFilter, whose properties are
 * (Endpoint/MesaUtilitiesBase/AccountingModels.cs:1064):
 *
 *   companyId, companyName, dateStart, dateEnd, clientFieldId, postedFilter, userIds
 *
 * cb2 was sending clientId / clientName / entryDateStart / entryDateEnd / userId /
 * billingObjectId. Newtonsoft **silently ignores** unknown JSON properties, so of
 * everything we sent only `postedFilter` — plus cb-api's injected `clientFieldId` —
 * ever bound. The filter arrived with null dates and no client/timekeeper scoping,
 * the proc's PTD/YTD windows computed against nulls and returned zeros, and Unbilled
 * Hours/Amount still populated because it isn't scoped by that window. No error
 * anywhere.
 *
 * That silence is why this survived two "fixes" aimed at cb-api's tenant field-id
 * injection: the injection was a red herring. Verified against cb-api-qa's live logs
 * on 2026-07-29 — the injection resolves and binds fine (neither of its two warnings
 * fires), and the columns were still zero.
 *
 * `userIds` is a pipe-delimited list with a trailing pipe, exactly as V1's
 * getFilterData builds it (Scripts/app/view/TimekeeperAnalysisHomeView.js:250).
 *
 * NOTE: the model has no matter/billing-object property at all, so a Matter filter
 * can never do anything server-side. V1's TKA offers only Client + Professional.
 * The page rendered one anyway until CC-50026 removed it (QA: "the filter should
 * be removed if unsupported").
 */
export const toTkaWireFilter = (f = {}) => ({
  companyId: f.clientId || null,
  companyName: f.clientName || '',
  dateStart: f.entryDateStart || null,
  dateEnd: f.entryDateEnd || null,
  userIds: f.userId ? `${f.userId}|` : '',
  postedFilter: f.postedFilter ?? null,
  print: false, // V1 sends it; harmless, and keeps the payload shape identical
})
